import { Col, Form, Input, Row } from 'antd'
import { useGetFamilyMembersByEmail } from 'api/Event/Dropin'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { convertToUtc } from 'helper/utility'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { GetFamilyMembersParams } from 'types/event/dropInAttendees'

const FindAccount = () => {
  const { id }: { id: string } = useParams()
  const [form] = Form.useForm()
  const [getMembersParams, setGetMembersParams] =
    useState<GetFamilyMembersParams>({
      eventId: id,
      email: '',
      today: convertToUtc(new Date()),
    })

  const {
    setAccountNotFoundModalOpen,
    setDropOutModalOpen,
    setFamilyEmail,
    setAccountFoundModalOpen,
    setCheckInFamilyMembers,
  } = eventAttendanceStore(store => ({
    setAccountNotFoundModalOpen: store.setAccountNotFoundModalOpen,
    setDropOutModalOpen: store.setDropOutModalOpen,
    setFamilyEmail: store.setFamilyEmail,
    setAccountFoundModalOpen: store.setAccountFoundModalOpen,
    setCheckInFamilyMembers: store.setCheckInFamilyMembers,
  }))

  const {
    data: familyMembersData,
    isLoading: isFamilyMembersLoading,
    isFetching: isFamilyMembersFetching,
    refetch: refetchFamilyMembers,
  } = useGetFamilyMembersByEmail(getMembersParams)

  const handleFormSubmit = (values: { email: string }) => {
    setFamilyEmail(values.email)
    setGetMembersParams(prevParams => ({ ...prevParams, email: values.email }))
  }

  useEffect(() => {
    if (getMembersParams.email) {
      refetchFamilyMembers()
    }
  }, [getMembersParams])

  useEffect(() => {
    if (familyMembersData && familyMembersData.length === 0) {
      setAccountNotFoundModalOpen(true)
      setDropOutModalOpen(false)
    } else if (familyMembersData && familyMembersData.length) {
      setCheckInFamilyMembers(familyMembersData)
      setAccountFoundModalOpen(true)
      setDropOutModalOpen(false)
    }
  }, [familyMembersData])

  return (
    <Form form={form} onFinish={handleFormSubmit}>
      <Form.Item
        name={'email'}
        rules={[
          {
            required: true,
            message: 'Please input email!',
          },
          {
            type: 'email',
            message: 'Please enter valid email!',
          },
        ]}
      >
        <Row className="mt-20px">
          <Col>
            <label className="input-label required-input">Parent's email</label>
            <Input
              name="notes"
              className="custom-input-field w-full"
              placeholder="example@gmail.com"
            />
          </Col>
        </Row>
      </Form.Item>
      <button type="submit" className="btn-prim mt-20px">
        {isFamilyMembersLoading || isFamilyMembersFetching ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          'Find account'
        )}
      </button>
    </Form>
  )
}

export default FindAccount
